import Img from 'react-image';

// 關閉 IMG 預設解碼，修 iOS 上 svg 無法顯示的錯誤。
// 原本設在 _app.js 的全域 defaultProps,會把 react-image 釘進每頁共用 chunk;
// 移到此 wrapper 後，react-image 只在實際用到圖片的頁面 chunk 載入。
(Img as any).defaultProps = {
	...(Img as any).defaultProps,
	decode: false,
};

export default Img;
